import React, { Component } from 'react';

import { Button } from 'react-bootstrap';

import * as constants from '../../config/constants/AppConstants';

const UI_SIZE = constants.AppSettings.UI_SIZE;

class CommonButton extends Component {

    constructor(props){
        super(props);
    }

    render = () => {
        let { task = '', inlineClass = '', callback, disabled = false, rounded = true, order = {}, operation = {}, forceOrdered = false, size = UI_SIZE ,Fixlabel = ''} = this.props;

        let MenuProps = constants?.ButtonProps[task] || {};
        
        let { variant = 'primary', icon = '', label = '' } = MenuProps;

        // let size = UI_SIZE, 
        let classname = 'btn-rounded';

        let iconColour = '';

        if(!rounded){ classname = ''; }

        /** Custom  Somethings : Search Button, Direction Button */
        if (['edit', 'up-direction', 'down-direction'].includes(task)) variant = '';

        if (task === 'up-direction') iconColour = 'text-success';
        if (task === 'down-direction') iconColour = 'text-danger';

        if (task === 'up-direction' && (Number(order.row) === 1 || Number(order.seq) === 1)) return null;
        if (task === 'down-direction' && Number(order.row) === Number(order.rows)) return null;

        if(['up-direction', 'down-direction'].includes(task)){
            if(operation?.Search === true && forceOrdered === false){ return null; }
        }

        return (
            <>
                <Button 
                    variant={variant} 
                    size={size} 
                    className={classname + ' ' + inlineClass}
                    disabled={disabled}
                    onClick={(e) => callback(e)}
                    >
                    <i className={`${icon} ${label ? 'me-1' : `${iconColour}`}`} />
                    {label !== '' && ' '+label}
                    {Fixlabel !== '' && ' '+Fixlabel}
                </Button>
            </>
        )
    }
}

export default CommonButton;